import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box } from '@mui/material';
import { QuestionCard } from './QuestionCard';
import { QuestionDTO, UpdateQuestionDTO } from '../dtos';

interface SortableQuestionCardProps {
  question: QuestionDTO;
  index: number;
  onUpdate: (questionId: string, data: UpdateQuestionDTO) => Promise<void>;
  onDelete: (questionId: string) => Promise<void>;
  isUpdating?: boolean;
  isDragDisabled?: boolean;
  isEditDisabled?: boolean;
  isDeleteDisabled?: boolean;
}

export const SortableQuestionCard: React.FC<SortableQuestionCardProps> = ({
  question,
  index,
  onUpdate,
  onDelete,
  isUpdating = false,
  isDragDisabled = false,
  isEditDisabled = false,
  isDeleteDisabled = false,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: question.id,
    disabled: isDragDisabled || isUpdating,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 1000 : 1,
    opacity: isDragging ? 0.8 : 1,
  };

  return (
    <Box ref={setNodeRef} style={style} {...attributes}>
      <QuestionCard
        question={question}
        index={index}
        onUpdate={onUpdate}
        onDelete={onDelete}
        isUpdating={isUpdating}
        isDragDisabled={isDragDisabled}
        isEditDisabled={isEditDisabled}
        isDeleteDisabled={isDeleteDisabled}
        dragHandleProps={listeners}
      />
    </Box>
  );
};
